export default class HomePage {
    constructor() {

    }

    init() {

        this.headerVideo({
            el: $('.js-header-video')
        });

        this.playPauseTicker();
        this.scrollToPlugin();

        this.slider({
            el: $('[data-slider="slider_1"]'),
            prevArrow: $('.js-templars-prev'),
            nextArrow: $('.js-templars-next'),
            fromNbr: $('.js-templars-from'),
            toNbr: $('.js-templars-to'),
        });

        this.sliderLR({
            el: $('[data-slider="slider_2"]'),
            navItem: $('.js-c-lr-item')
        });

        this.sliderLR({
            el: $('[data-slider="slider_3"]'),
            navItem: $('.js-c-lr-item')
        });

        this.audioPlay();

        // this.sliderAuthors({
        //     el: $('[data-slider="authors"]')
        // });

        this.expand();

        this.share($('.js-facebook-share'), $('.js-twitter-share'), $('.js-mail-share'));
    }

    shareSocial(engine) {

        const width = width || 600;
        const height = height || 300;

        let leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
        let topPosition = (window.screen.height / 2) - ((height / 2) + 50);
        let windowFeatures = "status=no,height=" + height + ",width=" + width + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";

        let u = location.href;
        let t = document.title;

        if (engine === 'facebook') {
            window.open('http://www.facebook.com/sharer.php?u=' + encodeURIComponent(u) + '&t=' + encodeURIComponent(t), 'sharer', windowFeatures);
        }

        if (engine === 'twitter') {
            let link = location.hostname + location.pathname;
            let twitter_status = '';
            window.open('https://twitter.com/home?status=' + encodeURIComponent(twitter_status) + encodeURIComponent(' ') + encodeURIComponent(link), 'sharer', windowFeatures);
        }

    }

    share(facebook, twitter, mail) {

        facebook.click( (ev) => {
            ev.preventDefault();
            this.shareSocial('facebook');
        });

        twitter.click( (ev) => {
            ev.preventDefault();
            this.shareSocial('twitter');
        });

        mail.each(function () {

            const $this = $(this);

            const mail_to = encodeURIComponent($this.data('mail-to'));
            const mail_subject = encodeURIComponent($this.data('mail-subject'));
            const mail_body = encodeURIComponent($this.data('mail-body'));

            $this.attr('href', 'mailto:' + mail_to + '?&subject=' + mail_subject + '&body=' + mail_body);

        });

    }

    expand() {

        $('.js-expand').each(function() {
            const elheight = $(this).outerHeight();
            $(this).attr('data-height', elheight);
            TweenMax.set($(this), { height: 0 });
        });

        $('.js-read-more').on('click', function() {
            if($(this).attr('data-status') === 'off') {
                $(this).attr('data-status', 'on');
                $(this).html($(this).attr('data-text-expand'));
                TweenMax.to($(this).next('.js-expand'), 0.6, { height: $(this).next('.js-expand').attr('data-height') });
            } else {
                $(this).attr('data-status', 'off');
                $(this).html($(this).attr('data-text-normal'));
                TweenMax.to($(this).next('.js-expand'), 0.6, { height: 0 });
            }
        });

    }

    audioPlay(){

        $('.js-sound').on("click", function(ev)  {
            ev.preventDefault();
            if($(this).attr('data-status') === 'off') {

                document.getElementById('sanctus').pause();
                document.getElementById('jube_domine').pause();
                document.getElementById('tota_pulchra_est_maria').pause();

                $('.js-sound').removeClass('is-playing');
                $('.js-sound').attr('data-status', 'off');

                $(this).addClass('is-playing');
                $(this).attr('data-status', 'on');
                document.getElementById($(this).attr('data-link')).play();
            } else {
                $(this).attr('data-status', 'off');
                $(this).removeClass('is-playing');
                document.getElementById($(this).attr('data-link')).pause();
            }
        });

    }

    headerVideo(config) {
        let video = config.el;
        video[0].load();

        video[0].addEventListener('loadeddata', function() {
            video[0].play();
            // $('body').aClass('is-video-loading', 'is-video-playing');
        }, false);
    }

    playPauseTicker() {

        $(window).on('resize scroll', function() {
            $('.js-body-video').each(function() {
                if ($(this).isInViewport()) {
                    $(this)[0].play();
                } else {
                    $(this)[0].pause();
                }
            });
        });
    }

    slider(config) {

        config.el.on('init reInit', function(event, slick, currentSlide, nextSlide){
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            // var i = (currentSlide ? currentSlide : 0) + 1;
            // $status.text(i + '/' + slick.slideCount);
            config.toNbr.html(`0${slick.slideCount}`);
        });

        config.el.slick({
            prevArrow: config.prevArrow,
            nextArrow: config.nextArrow,
            lazyLoad: 'ondemand',
            speed: 500,
            fade: true,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        adaptiveHeight: true
                    }
                },
            ]
            // add the rest of your options here
        });

        // On before slide change
        config.el.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            config.fromNbr.html(`0${nextSlide + 1}`);
        });
        // On before slide change
        config.el.on('afterChange', function(event, slick, currentSlide) {
        });

    }

    sliderLR(config) {

        config.el.slick({
            arrows: false,
            lazyLoad: 'ondemand',
            speed: 500,
            fade: true,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        dots: true,
                        adaptiveHeight: true
                    }
                },
            ]
        });

        config.navItem.on('click', function(ev) {
            ev.preventDefault();
            $(this).parents('.c-lr-slider').find('.c-lr-slider__nav-item').removeClass('is-active');
            $(this).parent().addClass('is-active');
            config.el.slick('slickGoTo', parseInt($(this).attr('data-slide')), true);

        });
    }

    sliderAuthors(config) {

        config.el.slick({
            arrows: false,
            lazyLoad: 'ondemand',
            speed: 500,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 9999,
                    settings: "unslick"
                },
                {
                    breakpoint: 1140,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: true
                    }
                },
            ]
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        });

        let $slickGreen = false;
        $(window).on('resize orientationChange', function(event) {
            //check window.width()... $('.slider').slick('reinit'); });
            if($(window).width() < 1140) {
                if(!$slickGreen){
                    config.el.slick('reinit');
                    $slickGreen = true;
                }
            } else {
                $slickGreen = false;
            }
        });
    }

    scrollToPlugin() {
        $('.js-scroll-to').on('click touchstart', function(ev) {
            ev.preventDefault();
            let offset = 0;
            const scroolToAnchor = $(this).attr('data-target'),
                scrollToOffset = $('.c-navigation').outerHeight();

            if (scrollToOffset) {
                offset = scrollToOffset;
            }
            if ($(scroolToAnchor).length) {
                TweenMax.to($('html, body'), 1, {
                    scrollTop: $(scroolToAnchor).offset().top - offset,
                    ease: Power2.easeOut
                });
            }
        });
    }
}


// WEBPACK FOOTER //
// ./static/js/pages/HomePage.js